export default __webpack_public_path__ + "static/media/300x600-1.80bff9f8.gif";